module.exports = __webpack_public_path__ + "img/chargingport_1000.3f5e6c0a.png";